import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { Button, Typography } from "@platform/design-system";
import React from "react";

import { submitEvent } from "../../../utils/tracking";

const RfpRemoveCoverage = ({
  isOpen,
  onClose,
  onCancel,
  onSubmit,
  coverageName,
  rfpId,
  clientType,
}) => (
  <Dialog
    open={isOpen}
    onClose={onClose}
    aria-labelledby="alert-remove-cov-title"
    aria-describedby="alert-remove-cov-description"
    maxWidth={"sm"}
  >
    <DialogTitle id="alert-remove-cov-title">Remove Coverage</DialogTitle>
    <DialogContent id="alert-remove-cov-description">
      <Typography mb={3}>
        Removing a coverage will delete any existing data entered for that
        coverage type.
      </Typography>
      <Typography>
        Are you sure you want to remove{" "}
        <Typography component="span">
          <strong>{coverageName}</strong>
        </Typography>
        ?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} variant="tertiary">
        No, cancel
      </Button>
      <Button
        onClick={() => {
          submitEvent("RFP Coverage Removed", {
            rfp_id: rfpId,
            coverage_name: coverageName,
            client_type: clientType,
          });
          onSubmit();
        }}
        // TODO(eslint): fix no-autofocus
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        variant="primary"
      >
        Yes, remove coverage
      </Button>
    </DialogActions>
  </Dialog>
);

export default RfpRemoveCoverage;
